import React from 'react';
import { TagInput } from 'design-system-web';

import { DOMAIN_REGEX } from '../../constants';

interface DomainTagInputProps {
  value: string[];
  onChange: (domains: string[]) => void;
}

export function DomainTagInput({ value = [], onChange }: DomainTagInputProps) {

  const validateDomain = (domain: string): boolean => {
    return DOMAIN_REGEX.test(domain);
  };

  return (
    <TagInput
      id="vantify-domain-input"
      tags={value}
      setTags={onChange}
      validateTag={validateDomain}
      placeholder="Enter domain names (e.g. domain.com)"
      errorText="Please enter valid domain names (e.g. domain.com)"
    />
  );
}
